<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <a-row :gutter="24">
          <a-row :gutter="24">
            <a-col :md="24" :sm="24" ref="reference">
              <a-form-item label="单号">
                <a-textarea
                  :style="{ maxWidth: '100%', width: inputWidht }"
                  @change="changeValue"
                  @blur="Fetchvalue"
                  auto-size
                  placeholder="(支持批量下载)HD0000042936,HD0000042937"
                  v-decorator="[
                    'docCode',
                    {
                      rules: [{ required: true, message: '请输入完整单号' }],
                      getValueFromEvent: (event) => event.target.value.replace(/\s+/g, ''),
                    },
                  ]"
                ></a-textarea>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="6">
              <a-form-item label="品类">
                <j-dict-select-tag
                  type="list"
                  @blur="Fetchvalue"
                  :trigger-change="true"
                  v-decorator="['type', { rules: [{ required: true, message: '请选择品类' }] }]"
                  placeholder="请选择品类"
                  dictCode="mpr_type"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col> -->
            <a-col :md="6" :sm="6">
              <a-form-item label="炸单基地">
                <j-dict-select-tag
                  type="radio"
                  @change="Fetchvalue"
                  :trigger-change="true"
                  v-decorator="['factoryAddress', { rules: [{ required: true, message: '请选择炸单基地' }] }]"
                  placeholder="请选择炸单基地"
                  dictCode="mpr_factory_address"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="6">
              <a-form-item label="文件路径">
                <j-dict-select-tag
                  type="list"
                  @change="Fetchvalue"
                  :trigger-change="true"
                  v-decorator="['folder', { rules: [{ required: true, message: '请选择文件路径' }] }]"
                  placeholder="请选择文件路径"
                  dictCode="mpr_folder"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <!-- style="float: right; overflow: hidden" -->
            <span class="table-page-search-submitButtons">
              <a-col :md="24" :sm="24" style="display: flex; justify-content: end">
                <a-button type="primary" @click="inquireClick" icon="search">查询</a-button>
                <a-button
                  type="primary"
                  @click="downloadsearchQuery"
                  :disabled="dataSource.length == 0"
                  icon="vertical-align-bottom"
                  style="margin-left: 8px"
                  >下载</a-button
                >
                <a-button type="primary" @click="downloadsearchReset" icon="reload" style="margin-left: 8px"
                  >重置</a-button
                >
                <!-- <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button> -->
              </a-col>
            </span>
          </a-row>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator"></div>
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :scroll="{ x: 'max-content' }"
        :loading="loading"
        @change="handleTableChange"
      >
        <div
          slot="filterDropdown"
          slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px"
        >
          <a-input
            v-ant-ref="(c) => (searchInput = c)"
            :placeholder="`请输入文件名称模糊搜索!`"
            :value="selectedKeys[0]"
            style="width: 188px; margin-bottom: 8px; display: block"
            @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
          />
          <a-button
            type="primary"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
          >
            查询
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)"> 重置 </a-button>
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered"
          type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
        <template slot="izActivity" slot-scope="text">
          <span v-if="text === 1" class="green">启用</span>
          <span v-if="text === 0" class="red">禁用</span>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JInput from '@comp/jeecg/JInput'
import { getAction } from '@/api/manage'
import { ajaxGetDictItems } from '@/api/api'
export default {
  name: 'DownloadModule',
  mixins: [JeecgListMixin],
  components: {
    JInput,
  },
  data() {
    return {
      description: 'mpr文件下载',
      form: this.$form.createForm(this),
      url: {
        list: '/base/ftpFileInfo/fileList',
        mprDownload: '/base/ftpFileInfo/mprDownload',
        queryMprRecord: '/base/ftpFileInfo/queryMprRecord', //请求是否存在文件
      },
      dictOptions: {},
      columns: [
        {
          title: '文件名称',
          align: 'center',
          dataIndex: 'key',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) => record.key.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              }, 0)
            }
          },
        },
        {
          title: '修改时间',
          align: 'center',
          dataIndex: 'lastModified',
        },
        {
          title: '文件大小',
          align: 'center',
          dataIndex: 'size',
          customRender: function (t) {
            return t + 'b'
          },
        },
      ],
      disableMixinCreated: true,
      ftpDownloadUrl: process.env.VUE_APP_domianURL,
      YGlist: [],
      CGlist: [],
      inputWidht: '350px',
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  mounted() {
    // this.queryParam.docCode = 'HD0000042936'
    // this.queryParam.factoryAddress = '2'
    // this.queryParam.type = '1'
    // this.$refs.DownloadModuleModal.edit()
    // jpgl_mpr_closet
    // jpgl_mpr_kitchen
    const that = this
    ajaxGetDictItems('jpgl_mpr_closet', null).then((res) => {
      console.log(res.result)
      that.YGlist = res.result.map((item) => item.value)
    })
    ajaxGetDictItems('jpgl_mpr_kitchen', null).then((res) => {
      console.log(res.result)
      that.CGlist = res.result.map((item) => item.value)
    })
  },
  methods: {
    // 动态设置单号长度
    changeValue() {
      let value = this.form.getFieldsValue(['docCode']).docCode
      let length = value ? value.length : 0
      console.log(this.$refs.reference.$el.clientWidth)
      let maxLength = (this.$refs.reference.$el.clientWidth - 70) / 10
      if (length > 31 && length < maxLength) {
        this.inputWidht = length * 10 + 'px'
      } else if (length < 31 || length == 0) {
        this.inputWidht = '350px'
      }
    },
    Fetchvalue() {
      this.$nextTick(function () {
        let values1 = this.form.getFieldsValue()
        let isEmpty = true
        Object.keys(values1).forEach(function (key) {
          if (values1[key] == null || values1[key] == undefined || values1[key] == '') {
            isEmpty = false
          }
        })
        if (isEmpty) {
          // 全部又值处理逻辑
          this.inquireClick()
        }
      })
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },

    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    //  点击查询的时候触发
    inquireClick() {
      const that = this
      that.form.validateFields((err, values) => {
        if (!err) {
          that.CGlist.forEach((item) => {
            if (values.docCode.indexOf(item) == 0) {
              values.type = '1'
            }
          })
          if (!values.type) {
            that.YGlist.forEach((item) => {
              if (values.docCode.indexOf(item) == 0) {
                values.type = '2'
              }
            })
          }
          that.queryParam = values
          if (!!!values.type) {
            return this.$message.warning('当前订单单号类型不存在！')
          }
          if (values.docCode && values.factoryAddress && values.type) {
            that.searchQuery()
          }
          console.log(values)
        }
      })
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      this.ipagination = pagination
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() //查询条件
      this.loading = true
      this.dataSource = []
      getAction(this.url.list, params).then((res) => {
        console.log(res)
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.pageRefresh++
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    // 关闭路由
    CloseRoute() {
      window.close()
    },
    initDictConfig() {},
    downloadsearchQuery() {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          // getAction(that.url.queryMprRecord, values).then((res) => {
          //   console.log(res)
          //   if (res.code == 200) {

          this.CGlist.forEach((item) => {
            if (values.docCode.indexOf(item) == 0) {
              values.type = '1'
            }
          })
          if (!values.type) {
            this.YGlist.forEach((item) => {
              if (values.docCode.indexOf(item) == 0) {
                values.type = '2'
              }
            })
          }
          console.log('4654')
          if (!!!values.type) {
            return this.$message.warning('当前订单类型不存在！')
          }
          let url =
            that.ftpDownloadUrl +
            `/base/ftpFileInfo/mprDownload?factoryAddress=${values.factoryAddress}&type=${values.type}&folder=${values.folder}&docCode=${values.docCode}`
          console.log(url)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', values.docCode + '.zip')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
          this.$message.success('下载文件成功！')
          this.downloadsearchReset()
          // } else {
          //   this.$message.warning(res.message)
          // }
          // })
        }
      })
    },
    downloadsearchReset() {
      this.form.resetFields()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.table-page-search-wrapper {
  width: 100%;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}
</style>
